import { hostName } from "../../../config/config";
import { mergeChunkCache } from "../cache/chunkMerge";

export function getImageProxyBaseUrl(reportData) {
  return (
    reportData?.imageProxyBaseUrl ??
    `${hostName}/api/Inspection/api/image?blobUrl=`
  );
}

export function resolvePageContext(page, chunkCache, routeParams) {
  const staticData = chunkCache[1];
  if (!staticData || !page) return null;

  const reportData =
    page.chunkId === "action-plan"
      ? mergeChunkCache(chunkCache)
      : staticData;

  const imageProxyBaseUrl = getImageProxyBaseUrl(reportData);
  const propLogo = reportData?.propShieldLogoBase64;
  const logodata = { propShieldLogoBase64: propLogo };

  const preReq = {
    clientnameParam: routeParams?.clientNameParam ?? "",
    propertyMasterId: routeParams?.propertyMasterId,
    inspectionReferenceNumber: routeParams?.inspectionReferenceNumber,
  };

  const base = {
    page,
    reportData,
    imageProxyBaseUrl,
    logodata,
    preReq,
    pageNum: page.pageNum,
  };

  if (
    !page.doorId ||
    page.chunkId === "static" ||
    page.chunkId === "action-plan"
  ) {
    return base;
  }

  const chunk = chunkCache[page.chunkId];
  if (!chunk) return { ...base, missingChunk: true };

  const pir = chunk.propertyInspectionReport ?? {};
  const door = (pir.combinedDoors ?? []).find(
    (d) => d.inspectedDoorId === page.doorId,
  );
  if (!door) return { ...base, missingChunk: true };

  const doorId = page.doorId;
  const complianceList = (pir.complianceChecks ?? []).filter(
    (x) => x.inspectedDoorId === doorId,
  );
  const physicalList = (pir.physicalMeasurements ?? []).filter(
    (x) => x.doorId === doorId,
  );
  const originalDoor = (pir.inspectedDoors ?? []).find(
    (x) => x.inspectedDoorId === doorId,
  );
  const additionalPhotos = (pir.additionalInfos ?? []).find(
    (x) => x.inspectedDoorId === doorId,
  );

  return {
    ...base,
    door,
    complianceList,
    physicalList,
    originalDoor,
    additionalPhotos,
  };
}
